type AppMode = 'tg' | 'web'

const mode = (import.meta.env.VITE_APP_MODE ?? 'tg') as AppMode

export const ENV = {
  APP_MODE: mode,
  IS_TG: mode === 'tg',
  IS_WEB: mode === 'web',
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL ?? '',
  IS_DEV: import.meta.env.DEV,
  IS_PROD: import.meta.env.PROD
} as const
